<div class="backdrop" (click)="onClose()"></div>
<div class="alert alert-warning countdown-box">
    <h4 class="alert-heading">{{ 'modCountdownTitle' | translate}}</h4>
    <p>{{ 'modCountdownMessage' | translate}} {{counter}}</p>
    <div class="countdown-box-actions">
        <button class="btn btn-secondary" (click)="onClose()">{{ 'close' | translate }}</button>
    </div>
</div>